module.exports = __webpack_public_path__ + "static/img/SearchDetailRecruit1.95af9a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailRecruit1.png
// module id = 770
// module chunks = 0